var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthcareSite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#c0c0c0;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 23",
    id: "Layer_23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 4,
    width: 60,
    x: 2,
    y: 58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 4,
    width: 56,
    x: 4,
    y: 54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6,
    x2: 6,
    y1: 54,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 58,
    x2: 58,
    y1: 54,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18,
    x2: 18,
    y1: 34,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46,
    x2: 46,
    y1: 34,
    y2: 54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "24 54 24 38 40 38 40 54"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32,
    x2: 32,
    y1: 38,
    y2: 54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 8,
    width: 4,
    x: 10,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 8,
    width: 4,
    x: 50,
    y: 38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6,
    x2: 6,
    y1: 30,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 58,
    x2: 58,
    y1: 30,
    y2: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 4,
    width: 60,
    x: 2,
    y: 30
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "23 10 2 10 2 6 23 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41 6 62 6 62 10 41 10"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 12,
    width: 18,
    x: 23,
    y: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32,
    x2: 32,
    y1: 5,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29,
    x2: 35,
    y1: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 8,
    width: 8,
    x: 10,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 8,
    width: 8,
    x: 22,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 8,
    width: 8,
    x: 34,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 8,
    width: 8,
    x: 46,
    y: 18
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcareSite);
export default __webpack_public_path__ + "static/media/healthcare-site.27ec6f1e74ffd94f6f35e425ed9ac152.svg";
export { ForwardRef as ReactComponent };